export default "__VITE_ASSET__B0MVPebx__"